import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import {
  DRAWER_CONTENT_CLASS,
  type TDrawerContentElement,
  type TDrawerContentProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { DrawerOverlay } from "@/ui/components/overlay/Drawer/DrawerOverlay";
import { DrawerPortal } from "@/ui/components/overlay/Drawer/DrawerPortal";
import { cn } from "@/ui/lib/utils";

export const DrawerContent = forwardRef<TDrawerContentElement, TDrawerContentProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerPrimitive.Content
        data-component="DrawerContent"
        ref={ref}
        className={cn(DRAWER_CONTENT_CLASS, className)}
        {...props}
      >
        { children }
      </DrawerPrimitive.Content>
    </DrawerPortal>
  ),
);

DrawerContent.displayName = "DrawerContent";
